const clean = '00'; // collateral clean
const property = '10'; // collateral property
const quotedShares = '21'; // collateral quoated shares
const unquotedShared = '22'; // collateral unquoted shared
const unitTrusts = '23'; // collateral unit trusts
const otherFinancialAssets = '29'; // collateral other financial assets
const motorVehicle = '30'; // collateral motor vehicle
const otherVehicle = '40'; // collateral other vehicle
const concessionContractual = '50'; // collateral concession and contractual rights
const plantMachinery = '60'; // collateral plant and machinery
const financialGuarantee = '70'; // collateral financial guarantee
const negativePledge = '80'; // collateral negative pledge
const otherAssets = '00'; // collateral other assets
const secured = '99'; // collateral secured (details unknown)

export const COLLATERAL_CODES = [
  clean,
  property,
  quotedShares,
  unquotedShared,
  unitTrusts,
  otherFinancialAssets,
  motorVehicle,
  otherVehicle,
  concessionContractual,
  plantMachinery,
  financialGuarantee,
  negativePledge,
  otherAssets,
  secured,
];

export const isCollateralCodeVehicle = code => [
  motorVehicle,
  otherVehicle,
].some(c => c === code);

export const isCollateralCodePersonal = code => [
  clean,
  property,
  unitTrusts,
  otherFinancialAssets,
  secured,
].some(c => c === code);

export const isCollateralCodeOther = code => !isCollateralCodeVehicle(code)
  && !isCollateralCodePersonal(code);



// WEBPACK FOOTER //
// ./src/constants/collateralCodes.js